<h2 mat-dialog-title>{{ 'scim-administration.policyMaps.detail.title' | translate }}</h2>
<mat-dialog-content>
	<div class="detail-field">
		<label>{{ 'scim-administration.policyMaps.detail.groupExternalId' | translate }}</label>
		<p>{{ data.groupExternalId }}</p>
	</div>
	<div class="detail-field">
		<label>{{ 'scim-administration.policyMaps.detail.policyId' | translate }}</label>
		<p>{{ data.policyId }}</p>
	</div>
	<div class="detail-field">
		<label>{{ 'scim-administration.policyMaps.detail.id' | translate }}</label>
		<p>{{ data.id }}</p>
	</div>
	<div class="detail-field">
		<label>{{ 'scim-administration.policyMaps.detail.createdAt' | translate }}</label>
		<p>{{ data.createdAt | aciesDateFormat: true }}</p>
	</div>
	<div class="detail-field">
		<label>{{ 'scim-administration.policyMaps.detail.createdBy' | translate }}</label>
		<p>{{ data.createdBy }}</p>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button (click)="onClose()">{{ 'general.close' | translate }}</button>
</mat-dialog-actions>
